'use client';

import { useState, useEffect } from 'react';
import BlogArticleCard from './BlogArticleCard';
import CategoryFilter from './CategoryFilter';

interface BlogArticle {
  id: string;
  title: string;
  excerpt: string;
  category: string;
  author: string;
  date: string;
  readTime: string;
  image: string;
  alt: string;
  slug: string;
}

interface Category {
  id: string;
  name: string;
  icon: string;
  count: number;
}

const BlogInteractive = () => {
  const [isHydrated, setIsHydrated] = useState(false);
  const [activeCategory, setActiveCategory] = useState('all');

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const categories: Category[] = [
  { id: 'all', name: 'All Articles', icon: 'NewspaperIcon', count: 2 },
  { id: 'dive-reports', name: 'Dive Reports', icon: 'DocumentTextIcon', count: 0 },
  { id: 'marine-life', name: 'Marine Life Sightings', icon: 'SparklesIcon', count: 0 },
  { id: 'conservation', name: 'Conservation', icon: 'ShieldCheckIcon', count: 1 },
  { id: 'conditions', name: 'Diving Conditions', icon: 'CloudIcon', count: 0 },
  { id: 'community', name: 'Community Stories', icon: 'UserGroupIcon', count: 1 }];


  const articles: BlogArticle[] = [
  {
    id: '2',
    title: 'Posidonia oceanica in Cyprus – Protected Seagrass Meadows and Marine Life Guide for Divers',
    excerpt: 'If you have ever dived in Cyprus, you have seen it. Stretching across sandy bays and gently sloping seabeds, forming dense green underwater meadows — Posidonia oceanica is one of the most important marine habitats in the Mediterranean. This guide explains what it is, what marine life lives there, why it is legally protected, and how divers can help preserve it.',
    category: 'conservation',
    author: 'Demetra Regan',
    date: '2026-02-18',
    readTime: '9 min read',
    image: "/assets/images/shutterstock_2541104003-1771398118881.jpg",
    alt: 'Posidonia oceanica seagrass meadow Mediterranean ecosystem Cyprus underwater',
    slug: 'posidonia-oceanica-cyprus-protected-seagrass'
  },
  {
    id: '1',
    title: 'Tipping in Cyprus for Divers: Should You Tip at Dive Centres?',
    excerpt: 'If you are planning a scuba diving holiday in Cyprus, one question often comes up: Should you tip at dive centres in Cyprus – and if so, how much? This guide explains clearly and honestly what is expected, how Cyprus differs from major dive destinations, and how you can show appreciation in a way that fits local culture.',
    category: 'community',
    author: 'Demetra Regan',
    date: '2026-02-06',
    readTime: '8 min read',
    image: "/assets/images/image-1770729113628.png",
    alt: 'Illustrated octopus with diving gear and tipping jar representing Cyprus dive centre tipping guide',
    slug: 'tipping-in-cyprus-for-divers'
  }];


  const filteredArticles = activeCategory === 'all' ?
  articles :
  articles.filter((article) => article.category === activeCategory);

  if (!isHydrated) {
    return (
      <div className="space-y-8">
        <div className="flex justify-center">
          <div className="animate-pulse h-12 w-64 bg-muted rounded-lg"></div>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {[1, 2, 3, 4, 5, 6].map((i) =>
          <div key={i} className="animate-pulse bg-card rounded-xl h-96"></div>
          )}
        </div>
      </div>);

  }

  return (
    <div className="space-y-8">
      <CategoryFilter
        categories={categories}
        activeCategory={activeCategory}
        onCategoryChange={setActiveCategory} />


      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {filteredArticles.map((article) =>
        <BlogArticleCard key={article.id} article={article} />
        )}
      </div>

      {filteredArticles.length === 0 &&
      <div className="text-center py-12">
          <p className="text-muted-foreground text-lg">No articles found in this category.</p>
        </div>
      }
    </div>);

};

export default BlogInteractive;